import { create } from "zustand";
import { InvestorEvidenceRequestOverview, RqdEvidenceTypeWithDocCategories } from "../api/transformers/requiredEvidence";
import { RqdEvidenceAPI } from "../api";

type InvestorEvidenceRequestStore = {
  data: InvestorEvidenceRequestOverview[],
  loading: boolean;
  error: unknown;
  fetchData: (personId: string, types: RqdEvidenceTypeWithDocCategories[]) => Promise<void>;
}

const useInvestorEvidenceRequestStore = create<InvestorEvidenceRequestStore>((set) => ({
  data: [],
  loading: true,
  error: null,
  // actions
  fetchData: async (personId, types) => {
    set({ loading: true, error: null, data: [] });
    try {
      const result = await RqdEvidenceAPI.getInvestorEvidenceRequests(personId, types);
      set({ data: result, loading: false });
    } catch (err) {
      console.error(err);
      set({ error: err, loading: false });
    }
  }
}));


export default useInvestorEvidenceRequestStore;
